export default __webpack_public_path__ + "static/not-found-illu-a3472fb627c53873a566271e760cfada.svg";